import React, { useState, useEffect } from "react";
import {
  FormStyle,
} from "../../login/components/RightSideContainer";
import { Button } from "../../../components/Button";
import {
  EKYC_COUPON_LOGIN_TITLE,
  EKYC_LOGIN_TITLE,
} from "./constant";
import { useHistory } from "react-router-dom";
import { EKYC } from "../../../helpers/constants/routes";
import CommonInput from "../../login/componentLoginScreen/CommonInput";
import { triggerSimpleAjax } from "../../../helpers/httpHelper";
import { LOGOUT_ALL_SESSION } from "../../../helpers/constants/apiUrl";
import { MobileTextBox } from "../../../components/MobileTextBox";
import FooterMobile from "../../login/components/FooterMobile";
import { getDeviceType } from "../../../utils/CommonFunction.js";
import { DeviceType } from "../../../helpers/constants/constant.js";
import { LOGIN_API } from "../../../helpers/constants/ekycApiUrl.js";

const VerifyCouponCode = () => {
  const history = useHistory();
  const [data, setData] = useState({
    couponCode: "",
    isError: false,
    errorObj: {},
    isLoading: false,
    isSessionClear: false,
    mobileView: false,
  });

  useEffect(() => {
    const mobileView =
      getDeviceType() === DeviceType.MOBILE ||
      getDeviceType() === DeviceType.TABLET;
    if (mobileView) {
      setData({
        mobileView: true,
      });
    }
    const data = JSON.parse(localStorage.getItem("451")) || {};
    if (Object.keys(data).length) {
      setData({
        isSessionClear: true,
        isError: true,
        errorObj: {
          ...data,
        },
      });

      localStorage.removeItem("451");
    }
  }, []);

  const onChangeAction = (e) => {
    const { name, value } = e.target;
    if (value.length === 11) {
      return false;
    }
    setData({ ...data, [name]: value });
  };

  const loginWithCoupon = () => {
    const code = data.couponCode?.trim();

    if (!code) {
      setData({
        ...data,
        isError: true,
        errorObj: { login_username: "Please enter a coupon code." },
      });
      return;
    }

    if (code.length !== 6) {
      setData({
        ...data,
        isError: true,
        errorObj: { login_username: "Coupon code must be 6 digits." },
      });
      return;
    }

    setData({ ...data, isLoading: true });

    triggerSimpleAjax(
      LOGIN_API,
      "POST",
      {
        login_username: code,
        method_of_login: "coupon_based_registration",
        platform: "my_track",
      },
      (response) => {
        console.log("Coupon Login Success:", response);

        setData({ ...data, isLoading: false });
        const name = response?.user_data?.name;
        const phone = response?.user_data?.phone_number;
        const username = response?.user_data?.username;

        history.push(EKYC.COUPON_USER_DETAILS, {
          couponCode: code,
          mobileView: data.mobileView,
          name: name,
          username: username,
          phone: phone,
        });
      },
      (error) => {
        console.log("Coupon Login Failed:", error);

        setData({
          ...data,
          isLoading: false,
          isError: true,
          errorObj: { login_username: error?.detail || "Invalid coupon code" },
        });
      },
    );
  };

  const navigateToCouponLogin = (e) => {
    e && e.preventDefault();
    history.push(EKYC.LOGIN);
  };

  return data.mobileView ? (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "90%",
          maxWidth: "440px",
          padding: "2.5rem 1.5rem",
          marginTop: "-30px",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.05)",
          zIndex: 2,
        }}
      >
        <h3 style={{ fontSize: 18, fontWeight: "600", color: "#333", marginBottom: "8px" }}>Login With Coupon Code 👋</h3>
        <p style={{ padding: 0, margin: "0 0 15px 0", fontSize: 14, color: "#666", textAlign: "center" }}>
          {EKYC_COUPON_LOGIN_TITLE}
        </p>
        <FormStyle style={{ width: "100%" }}>
          <MobileTextBox
            labelName="Enter Coupon Code"
            name={"couponCode"}
            // check="ekycInput"
            value={data.couponCode}
            type="alphanumeric"
            onChange={onChangeAction}
            error={data.isError}
            errorMessage={data.errorObj?.login_username}
          />
          <Button
            type="submit"
            onClick={loginWithCoupon}
            isLoading={data.isLoading}
            width="100%"
            bgColor="#4770C1"
            borderRadius="8px"
            fontStyle={{ fontSize: "14px", marginTop: "35px" }}
            boxHeight="38px"
          >
            {data.isSessionClear ? "Logout All Session" : "Verify Coupon Code"}
          </Button>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              marginTop: "35px",
            }}
          >
            <p style={{ margin: 0, fontSize: "15px", color: "#666" }}>Return To</p>

            <span
              onClick={navigateToCouponLogin}
              style={{
                fontSize: "15px",
                color: "#4770C1",
                textDecoration: "underline",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Login
            </span>
          </div>
        </FormStyle>
      </div>

      <div style={{ alignItems: "center", marginTop: "20px", width: "90%", maxWidth: "440px" }}>
        <FooterMobile textStyle="small" showSecuritySection={true} />
      </div>
    </>
  ) : (
    <form className="login-Form" onSubmit={(e) => { e.preventDefault(); loginWithCoupon(); }}>
      <h2 className="login-heading" style={{ marginBottom: 20 }}>
        Login With Coupon Code 👋
      </h2>
      <p style={{ color: "#777", marginBottom: 30, fontSize: "16px", fontFamily: "barlow" }}>
        {EKYC_COUPON_LOGIN_TITLE}
      </p>

      <CommonInput
        type="text"
        label="Coupon Code"
        name="couponCode"
        value={data.couponCode}
        onChange={onChangeAction}
        error={data.isError ? data.errorObj?.login_username : ""}
        autoFocus
      />

      <div
        style={{
          width: "70%",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "45px",
          alignItems: "center",
        }}
      >
        <button
          className="next-button"
          type="submit"
          disabled={data.isLoading}
        >
          {data.isSessionClear ? "Logout All Session" : "Verify Coupon Code"}
        </button>

        <span
          onClick={navigateToCouponLogin}
          style={{
            fontSize: "16px",
            color: "#4770C1",
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: "500",
            fontFamily: "barlow",
          }}
        >
          Return to Login
        </span>
      </div>
    </form>
  );
};

export default VerifyCouponCode;
